export const systemConfigConstant = {
  runContext: 'default',
  baseModuleURL: '../mod/',
  staticDocumentsURL: 'https://www.365farmnet.com/wp-content/uploads/content/pdf/nutzungsbedingungen/',
  staticDocumentsUsageAgreement: 'ua_{0}.pdf',
  staticDocumentsTermsOfService: 'ANB-2017-12-19-{0}.pdf',
  staticDocumentsServiceLevelAgreement: 'sla_{0}.pdf',
  staticDocumentsPrivacyPolicy: '{0}_Datenschutzvereinbarung.pdf',
  supportedLanguages: ['de', 'en', 'pl', 'fr', 'bg'],
  supportedAngularLocales: ['aa', 'aa-dj', 'aa-er', 'aa-et', 'af', 'af-na', 'af-za', 'af-agq', 'af-agq-cm', 'ak', 'ak-gh', 'am', 'am-et', 'ar', 'ar-001', 'ar-ae', 'ar-bh', 'ar-dj', 'ar-dz', 'ar-eg', 'ar-eh', 'ar-er', 'ar-il', 'ar-iq', 'ar-jo', 'de', 'de-at', 'de-be', 'de-ch', 'de-de', 'de-li', 'de-lu', 'en', 'en-us', 'fr', 'fr-be', 'fr-bf', 'fr-bi', 'fr-bj', 'fr-bl', 'fr-ca', 'fr-cd', 'fr-cf', 'fr-cg', 'fr-ch', 'fr-ci', 'fr-cm', 'fr-dj', 'fr-dz', 'fr-fr', 'fr-ga', 'fr-gf', 'fr-gn', 'fr-gp', 'fr-gq', 'fr-ht', 'fr-km', 'fr-lu', 'fr-ma', 'fr-mc', 'fr-mf', 'fr-mg', 'fr-ml', 'fr-mq', 'fr-mr', 'fr-mu', 'fr-nc', 'fr-ne', 'fr-pf', 'fr-pm', 'fr-re', 'fr-rw', 'fr-sc', 'fr-sn', 'fr-sy', 'fr-td', 'fr-tg', 'fr-tn', 'fr-vu', 'fr-wf', 'fr-yt', 'pl', 'pl-pl', 'bg', 'bg-bg'],
  fallbackLocale: 'en',
  fallbackLocaleAngular: 'en-gb',
  fallbackCountry: 'UKN'
};

